export default class RawMaterialsController {
  constructor(ContentService, $uibModal, $state) {
    this.service = ContentService;
    this.modal = $uibModal;
    this.state = $state;
  }

  $onInit(){
    this.subscriptions = [];

    this.materials = [];

    this.subscriptions.push(
      this.service.getArticlesList().subscribe((articles) => {
        this.articles = articles;
      })
    );

    this.subscriptions.push(
      this.service.getAllMaterials().subscribe((data) => {
        this.materials = data.materials;
        console.log("loading...")
      })
    );

    this.amountsDeclared = {};
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  deleteMaterial(material, index){
    this.subscriptions.push(
      this.service.deleteMaterial(material.id).subscribe(() => {
        this.materials.pop(index);
      })
    );
  }

  changeMaterialExistence(material){
    this.subscriptions.push(
      this.service.changeMaterialExistence({
        quantity: this.amountsDeclared[material.id]
      }, material.id).subscribe(() => {
        material.existence += this.amountsDeclared[material.id];
        this.amountsDeclared[material.id] = 0;
      })
    );
  }

  associateProducts(material){
    this.state.go('rawMaterialArticles', {
      id: material.id,
      material: material
    });
  }

  openMaterialDialog(material){
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'raw-material-form.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $uibModalInstance) => {
        "ngInject";
        $scope.material = material || {
          existence: 0
        };
        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.optionsList = that.articles;

        $scope.registerMaterial = () => {
          that.subscriptions.push(
            that.service.registerMaterial({
              name: $scope.material.name, 
              notes: $scope.material.notes,
              existence: $scope.material.existence
            }).subscribe((material) => {
              that.materials.push(material);
              that.materials.sort((a,b) => a.name < b.name? -1 : a.name > b.name ? 1 : 0);
              $scope.closeThisDialog();
            })
          );
        };
        $scope.editMaterial = () => {
          that.subscriptions.push(
            that.service.editMaterial({
              name: $scope.material.name, 
              notes: $scope.material.notes
            }, $scope.material.id).subscribe((material) => {
              $scope.closeThisDialog();
            })
          );
        };
      }
    });
  }

}

 RawMaterialsController.$inject = ['ContentService', '$uibModal', '$state'];



// WEBPACK FOOTER //
// ./src/app/pages/raw-materials/raw-materials.controller.js